export default __webpack_public_path__ + "static/media/lemontbotanique_background_xl1.84ed1e41.jpg";